import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nomenclatorcasedeasigurari',
  templateUrl: './nomenclatorcasedeasigurari.component.html',
  styleUrls: ['./nomenclatorcasedeasigurari.component.css']
})
export class NomenclatorcasedeasigurariComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
